import * as React from "react";
import Box from "@mui/material/Box";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { InputInterface } from "../../../interfaces/InputInterface";
import { LoadingButton } from "@mui/lab";
import PrintIcon from "@mui/icons-material/Print";
import { requestApi } from "../../../helpers/RequestApi";
import { POST } from "../../../utils/MethodUtils";
import { PRINTERS_URL } from "../../../utils/UrlsUtils";
import { toastr } from "react-redux-toastr";
import getErrorApi from "../../../helpers/GetErrorApi";
import { useAppSelector } from "../../../app/hooks";
import { RootState } from "../../../app/store";
import Typography from "@mui/material/Typography";

interface FormState {
  emplacement: InputInterface;
}

interface State {
  printer: string;
}

const PrintEmplacementsComponent: React.FC<State> = React.memo(
  ({ printer }) => {
    const [loading, setLoading] = React.useState<boolean>(false);
    const getDefaultValues = React.useCallback((): FormState => {
      return {
        emplacement: {
          value: "",
          error: "",
        },
      };
    }, []);
    const token = useAppSelector((state: RootState) => state.globalState.token);
    const [values, setValues] = React.useState<FormState>(getDefaultValues());
    const { t } = useTranslation();
    const printEmplacements = React.useCallback(async () => {
      setLoading(true);
      const response = await requestApi({
        method: POST,
        path: PRINTERS_URL + "/print/emplacements",
        allowError: true,
        token: token,
        body: {
          emplacement: values.emplacement.value,
          printer: printer,
          printerTemplate: "TEXTE_QRCODE",
          quantity: 1,
        },
      });
      if (response.statusCode === 200) {
        toastr.success(t("word.success"), t("word.success"));
      } else {
        for (let message of getErrorApi(response.content)) {
          toastr.error(t("word.error"), t(message));
        }
      }
      setLoading(false);
    }, [printer, t, token, values.emplacement.value]);

    return (
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Typography>{t("sentence.printAllEmplacementsStartWith")}</Typography>
        <TextField
          autoComplete="off"
          sx={{ width: "100%", marginTop: 1 }}
          type="text"
          value={values.emplacement.value}
          onChange={(e) => {
            setValues((v) => {
              v.emplacement.value = e.target.value;
              return { ...v };
            });
          }}
        />
        <LoadingButton
          variant="text"
          color="inherit"
          sx={{
            borderRadius: "50%",
            minWidth: "auto",
            padding: "8px",
            color: "rgba(0, 0, 0, 0.54)",
          }}
          loading={loading}
          onClick={printEmplacements}
        >
          <PrintIcon />
        </LoadingButton>
      </Box>
    );
  }
);

export default PrintEmplacementsComponent;
